import gql from 'graphql-tag';

export const getMOCEventByHistoryId = gql`
  query getMOCEventByHistoryIds($id: String!, $historyId: Int) {
    getMOCEventByHistoryId(id: $id, historyId: $historyId) {
      id
      title
      MOCEventType {
        id
        name
        enabled
      }
      MOCEventAssociatedCategories {
        id
        MOCEventCategory {
          id
          name
          ShiftGroup {
            id
            name
          }
          enabled
        }
      }
      startDt
      endDt
      document
      description
      MOCEventEntries {
        id
        note
        createdBy
        createdAt
        updater
        updatedAt
      }
      MOCEventAORs {
        id
        AOR {
          id
          name
        }
      }
      MOCEventAcknowledgements {
        id
        Contact {
          id
          firstName
          lastName
        }
        acknowledged
        comments
        completedDt
        createdBy
        createdAt
        updater
        updatedAt
        deletedAt
        version
      }
      parentMocId
      historyId
      createdBy
      createdAt
      sapOutageNumber
      updater
      updatedAt
      deletedAt
      version
    }
  }
`;
